import { render, staticRenderFns } from "./InvoiceExtendDueDate.vue?vue&type=template&id=3ccd2fa4&"
import script from "./InvoiceExtendDueDate.vue?vue&type=script&lang=js&"
export * from "./InvoiceExtendDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports